import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { DischargeNoteReviewSection, DischargeNoteReviewSubSection } from './ReviewSections.component';
import { CalendarDateService } from '@uplift/services';

export type CourseOfTreatmentReviewSectionProps = {
  treatmentStartDate: string;
  treatmentEndDate: string;
  submittedSessionsCount: number;

  isSidebar?: boolean;
};

const formatDurationDate = (date: string) => {
  return CalendarDateService.date(date).format('MMMM DD, YYYY');
};

const getDurationOfTreatment = (treatmentStartDate: string | null, treatmentEndDate: string | null) => {
  if (!treatmentStartDate || !treatmentEndDate) {
    return null;
  }

  return `${formatDurationDate(treatmentStartDate)} – ${formatDurationDate(treatmentEndDate)}`;
};

export const CourseOfTreatmentReviewSection: React.VFC<CourseOfTreatmentReviewSectionProps> = props => {
  const { classes } = useCourseOfTreatmentReviewSectionStyles();

  const { treatmentStartDate, treatmentEndDate, submittedSessionsCount, isSidebar } = props;

  const durationOfTreatment = getDurationOfTreatment(treatmentStartDate, treatmentEndDate);

  if (isSidebar) {
    return (
      <DischargeNoteReviewSection title="Course of Treatment">
        <DischargeNoteReviewSubSection title="Duration of Treatment" isEmpty={!durationOfTreatment} emptyMessage="Not applicable">
          <Typography>{durationOfTreatment}</Typography>
        </DischargeNoteReviewSubSection>
        <DischargeNoteReviewSubSection title="Total Sessions">
          <Typography>{submittedSessionsCount}</Typography>
        </DischargeNoteReviewSubSection>
      </DischargeNoteReviewSection>
    );
  }

  return (
    <DischargeNoteReviewSection title="Course of Treatment">

      <DischargeNoteReviewSubSection title="Course of Treatment">
        <div className={classes.bold}>
          <Typography>
            <b>Duration of Treatment:</b> {!durationOfTreatment ? 'Not Applicable' : durationOfTreatment}
          </Typography>
          <Typography>
            <b>Total Sessions:</b> {submittedSessionsCount}
          </Typography>
        </div>
      </DischargeNoteReviewSubSection>

    </DischargeNoteReviewSection>
  );
};

const useCourseOfTreatmentReviewSectionStyles = makeStyles({ name: 'CourseOfTreatmentReviewSection' })({
  bold: {
    '& b': {
      fontWeight: 500,
    },
  },
});